/* istanbul ignore file */
// Coverage ignore: this module reads `import.meta.env` at file load (the
// `static.*` build-time-substituted constants) which Jest's CommonJS
// runtime cannot parse. Thin wrappers around getRuntimeConfig() are
// already exercised indirectly by runtimeConfig.spec.ts and the
// component tests that mock `environment.js`. See MEIS-12358 design.md
// Decision 4 for the export-shape rationale.

import { getRuntimeConfig, type DeployEnv } from "./runtimeConfig.js";

export type { DeployEnv };

// ============================================================================
// Build-time env-agnostic constants (`static.frontend` in frontend-envs.json
// or non-env metadata). Available at module load.
// ============================================================================

export const KEYCLOAK_AUTH_SERVER = import.meta.env.VITE_KEYCLOAK_AUTH_SERVER;
export const KEYCLOAK_REALM = import.meta.env.VITE_KEYCLOAK_REALM;
export const MXCALL_URL = import.meta.env.VITE_MXCALL_URL;
export const THREED_PLANNER_SHOW = import.meta.env.VITE_THREED_PLANNER_SHOW;
export const TERMS_AND_CONDITIONS_URL = import.meta.env
  .VITE_TERMS_AND_CONDITIONS_URL;
export const CMS_URL = import.meta.env.VITE_CMS_URL;
export const M1_MY_URL = import.meta.env.VITE_M1_MY_URL;
export const PDF_DASHBOARD_URL = import.meta.env.VITE_PDF_DASHBOARD_URL;
export const TOLGEE_CDN_URL = import.meta.env.VITE_TOLGEE_CDN_URL;
export const ROUTER_BASENAME = import.meta.env.VITE_ROUTER_BASENAME;

// ============================================================================
// Runtime env-specific accessors (`envs.<env>.frontend` in frontend-envs.json).
// MUST NOT be called before `loadRuntimeConfig()` has resolved — see
// runtimeConfig.ts. The bootstrap in app/index.tsx awaits config before
// mounting React, so any call from a React tree is safe.
// ============================================================================

export function getDeployEnv(): DeployEnv {
  return getRuntimeConfig().VITE_DEPLOY_ENV;
}

export function getGraphqlEndpointUri(): string {
  return getRuntimeConfig().VITE_GRAPHQL_URL;
}

export function getKeycloakClient(): string {
  return getRuntimeConfig().VITE_KEYCLOAK_CLIENT;
}

export function getThreedPlannerUrl(): string {
  return getRuntimeConfig().VITE_THREED_PLANNER_URL;
}

export function getIcalGeneratorEndpoint(): string {
  return getRuntimeConfig().VITE_ICAL_GENERATOR_ENDPOINT;
}

export function getGoogleMapsApiKey(): string {
  return getRuntimeConfig().VITE_GOOGLE_MAPS_API_KEY;
}

export function getEmbeddableWizardUrl(): string {
  return getRuntimeConfig().VITE_EMBEDDABLE_WIZARD_URL;
}

// Per-build identity (commit SHA), written by the deploy stage to
// `/config.json` `version`. Optional during the MEIS-12358 Phase 8 rollout
// — old infra deploy stages don't yet write the field. Returns `undefined`
// in that case; callers should treat the absence as "version unknown" and
// skip version-dependent logic (Sentry release tag, outdated-app dialog,
// etc.) rather than fail.
export function getVersion(): string | undefined {
  return getRuntimeConfig().version;
}
